import { UserSettings } from './userSettings';
import { Farm } from './farm';
import { LegalTemplateOption } from '../legalTemplateOption';
import { UserGroup } from './userGroup';
import { UiMode } from '../../../assets/data/enum/uiMode';

export class User {
  id: number;
  firstName: string;
  lastName: string;
  username: string;
  pictureUrl: string;
  enabled: boolean;
  accountExpired: boolean;
  accountLocked: boolean;
  passwordExpired: boolean;
  password: string;
  farm: Farm;
  welcomeCheck: boolean;
  authorities: Array<any>;
  yearDefault: number;
  userSettings: UserSettings;
  userMultiFarmToken?: string;
  temporary: boolean;
  legalLog?: Array<LegalTemplateOption>;
  preferredLanguage: string;
  preferredCountry: string;
  preferredMode: UiMode;
  userGroup: UserGroup;
  userGroupId?: number;
  enabledOnlyPersonalActivity: boolean;
  attemptNo?: number;
  name?: string;
  // REFACTOR: Remove this workaround and use userGroup.id instead ==> see `_employee.gson` on the BE

  constructor() {
    this.id = null;
    this.firstName = null;
    this.lastName = null;
    this.username = null;
    this.pictureUrl = null;
    this.enabled = true;
    this.accountExpired = null;
    this.accountLocked = null;
    this.passwordExpired = null;
    this.farm = null;
    this.welcomeCheck = null;
    this.authorities = null;
    this.yearDefault = null;
    this.userSettings = null;
    this.userMultiFarmToken = null;
    this.temporary = false;
    this.preferredMode = UiMode.FARM;
    this.userGroup = null;
    this.userGroupId = null;
    this.enabledOnlyPersonalActivity = null;
  }
}

/*
*********** MODELLO DI BACKEND **********************

package com.xfarm.api.v1.auth

import com.xfarm.api.v1.core.Farm
import com.xfarm.api.v1.core.Note
import groovy.transform.EqualsAndHashCode
import groovy.transform.ToString

@EqualsAndHashCode(includes='username')
@ToString(includes='username', includeNames=true, includePackage=false)
class User implements Serializable {

	private static final long serialVersionUID = 1

	transient springSecurityService

	string firstName
	string lastName
	string username
	string password
	string pictureUrl
	boolean enabled = false
	boolean accountExpired = false
	boolean accountLocked = false
	boolean passwordExpired = false
	boolean welcomeCheck = false
	Farm farm
	Date    dateCreated
	Date    lastUpdated

		static belongsTo = Farm
	static hasMany = [geoLocations: UserGeoLocation, notes: Note]

	Set<Role> getAuthorities() {
		UserRole.findAllByUser(this)*.role
	}
	def beforeInsert() {
		encodePassword()
	}

	def beforeUpdate() {
		if (isDirty('password')) {
			encodePassword()
		}
	}

	protected void encodePassword() {
		password = springSecurityService?.passwordEncoder ? springSecurityService.encodePassword(password) : password
	}

	static transients = ['springSecurityService']

	static constraints = {
		firstName 	blank: false
		lastName	blank: false
		username 	blank: false, unique: true, email: true
		password 	blank: false
		pictureUrl	blank: false, nullable: true, url: true
		farm		blank: false, nullable:true
		dateCreated nullable: true
		lastUpdated nullable: true
	}

	static mapping = {
		password column: '`password`'
		autoTimestamp true
	}
}


*/
